import ClickOutside from "./ClickOutside";
import VFocus from "./VFocus";

export default [
    ClickOutside,
    VFocus,
]